import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=6fc274e4&scoped=true"
import script from "./ContactContent.vue?vue&type=script&lang=ts"
export * from "./ContactContent.vue?vue&type=script&lang=ts"
import style0 from "./ContactContent.vue?vue&type=style&index=0&id=6fc274e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc274e4",
  null
  
)

export default component.exports